import * as React from "react";
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard";
import IMetric from "../../models/metrics/IMetric";
import { Goal } from "@curefit/gmf-common";
import {LCGoalEditorProps} from "../../components/patient/edit/LCGoalEditor";

interface LCGoalEditViewContProps {
    newConfigData: any,
    staticGoals: Goal,
    staticMetrics: IMetric,
    appointmentId: number,
    displayMode: EditViewDisplayMode
}

interface LCGoalEditViewContState {
    updatedGoals: any[]
}

export class LCGoalEditViewCont extends React.Component<LCGoalEditViewContProps, LCGoalEditViewContState> {

    constructor(props: LCGoalEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props)
    }

    getStateFromProps = (props: LCGoalEditViewContProps): LCGoalEditViewContState => {
        const updatedGoals = props.newConfigData.healthTarget && props.newConfigData.healthTarget.goals
            ? props.newConfigData.healthTarget.goals.map((goalItem: any) => ({ item: goalItem }))
            : []
        return {
            updatedGoals
        }
    }

    componentWillReceiveProps(nextProps: LCGoalEditViewContProps) {
        this.setState(this.getStateFromProps(nextProps))
    }

    getLCGoalEditViewContTemplateProps = () => {
        const editProps: LCGoalEditorProps = {
            updatedGoals: this.state.updatedGoals,
            staticGoals: this.props.staticGoals,
            staticMetrics: this.props.staticMetrics,
            updateGoals: this.updatePatientGoals
        }
        return {
            "view": editProps,
            "edit": editProps
        }
    }

    updatePatientGoals = (updatedGoals: {item: any}[]) => {
        this.setState({
            updatedGoals
        })
    }

    getSaveObject = () => {
        const goalsToBeSaved = this.state.updatedGoals.map((goal: any) => goal.item || {});
        return {
            goals: goalsToBeSaved,
            referenceId: (this.props.appointmentId || "").toString()
        }
    }

    handleSave = () => {}

    handleCancel = () => {}

    render() {
        return (
            <div className={"lc-goal-editview-cont"}>
                <EditViewCard
                    cardTitleDisplay={"Goals"}
                    templateName={"lcGoals"}
                    templateProps={this.getLCGoalEditViewContTemplateProps()}
                    lastEditedEpoch={new Date().getTime()}
                    saveActionHandler={this.handleSave}
                    cancelActionHandler={this.handleCancel}
                    displayMode={this.props.displayMode}
                />
            </div>
        )
    }
}